import $ from 'jQuery';

export default function() {
	setTimeout(function() {
		var size = $("#buttons-icons-person-card.tab-content-active .col-wrap .col-4").length;
		var x = 22;

		$('#buttons-icons-person-card.tab-content-active .col-wrap .col-4:lt('+x+')').show();

		$('#buttons-icons-person-card.tab-content-active #loadmore').click(function () {
			x = (x + 6 <= size) ? x + 6 : size;
			$('#buttons-icons-person-card.tab-content-active .col-wrap .col-4:lt('+x+')').show();

			if (x == size) {
				$('#buttons-icons-person-card.tab-content-active #loadmore').hide();
			}
		});
	}, 500);
}
